import type { IModel } from '../stores/model';
import type { IFSM } from '../stores/model/metamodel/fsm';

/**
 * Custom hook that produces the list of FSM for the given object type id.
 */
export function useFSMsForObjectType(model: IModel, objectTypeId: string): IFSM[] {
  const objectType = model.metamodel.getObjectTypeById(objectTypeId);
  if (objectType != null) {
    return objectType.fsms.slice();
  } else {
    return [];
  }
}
